import avatar1 from "../assets/images/avatar_mit_background.png"
import type_do from "../assets/images/tasktypes/do_2color.png"
import type_fetch from "../assets/images/tasktypes/fetch_2color.png"
import type_wait from "../assets/images/tasktypes/wait_2color.png"
import type_decide from "../assets/images/tasktypes/decide_2color.png"
import infos_do from "../assets/images/tasktypes/do_info.png"
import infos_fetch from "../assets/images/tasktypes/fetch_info.png"
import infos_wait from "../assets/images/tasktypes/wait_info.png"
import infos_decide from "../assets/images/tasktypes/decide_info.png"
import help_do from "../assets/images/tasktypes/do_help.png"
import help_fetch from "../assets/images/tasktypes/fetch_help.png"
import help_wait from "../assets/images/tasktypes/wait_help.png"
import help_decide from "../assets/images/tasktypes/decide_help.png"
import dpa_de from "../assets/legaltext/dpa_de.js"
import tou_de from "../assets/legaltext/tou_de.js"
import prompt from "../assets/ai/prompt_de.js"
import Constants from 'expo-constants';

// Keys ["version", "changed", "init", "users", "images", "icons", "remote", "temp", "legal",                                                           "user",                 , "server", "workflows", "tasks", "planned", "contacts", "settings", "deleted", "published",                               "wfMap", "notify"]
// Keys ['version', 'changed', 'init', 'users', 'images', 'icons', 'remote', 'temp', 'legal', 'ai', 'plannedNotifications', 'notificationsToBePlanned', 'user', 'cloudMessaging', 'server', 'workflows', 'tasks', 'planned', 'contacts', 'settings', 'deleted', 'published', 'commit', 'studio', 'market', 'wfMap', 'notify']
let initialState = {
    version: '3.6.4',
    changed: false,
    init: {
        user: {
            name: 'Unknown',
            isSignedIn: false
        },
        cloudMessaging:{
           token: ''
        },
        server: {
            url: 'https://test.app.ina.coach',
            api: '/api',
            online: false,
            token: null,
            sync: [],
            chat: [],
            ws: { id: null, connected: false, connecting: false, error: null, retries: 3 }
        },
        workflows: {},
        tasks: {
            high: [], // tasks with active timers
            active: [], // tasks started
            changed: [] // tasks new
        },
        planned: {
            plans: []
        },
        contacts: {
            requests: [
                {
                    completedAt: null,
                    createdAt: "2022-09-16T14:27:08.943518",
                    fromUser: {
                        id: avatar1,
                        mail: "nutzerA@ina.coach",
                    },
                    id: "f5da68e2-d856-42aa-8a1e-e753a8be6913",
                    toUser: {
                        id: avatar1,
                        mail: "nutzerB@ina.coach",
                    },
                },
            ],
            active: [],
            channels: [],
        },
        settings: {
            inAColor: null,
            showTOU: false,
            showDPA: false,
            hidePhoneButton: false,
            taskFilter: 0,
            hideVersion: false,
            contactTel: '',
            speechEnabled: false,
            changed: [],
            pinned: []
        },
        deleted: [],
        published: [],
    },
    users: {
    },
    images: {
        seq: 0,
        act: 0,
        cnt: { w: 0, u: 0 },
        err: 0,
        list: [],
        load: {}
    },
    icons: {
        types: [type_do, type_fetch, type_wait, type_decide],
        infos: [infos_do, infos_fetch, infos_wait, infos_decide],
        helps: [help_do, help_fetch, help_wait, help_decide]
    },
    remote: {
        loading: {},
        json: null,
        active: false
    },
    temp: {
        logs: [],
        screenshots: false
    },
    legal: {
        tou_de: {
            version: '1_2_20240131',
            html: tou_de
        },
        dpa_de: {
            version: '1_4_20230908',
            html: dpa_de
        },
    },
    ai: {
        prompt: prompt
    },
    plannedNotifications:[],
    notificationsToBePlanned: []
}

// merge the init state into the main state
initialState = { ...initialState, ...initialState.init }

if (__DEV__) {
    console.dID = console.dID || ('' + Date.now()).substr(-4, 4)
    console.ina = function (...args) {
        console.log(console.dID, ...args)
        // violates immutable state
        // initialState.temp.logs.push(args)
    }
} else {
    console.ina = function (...args) {
        console.log(...args)
        // violates immutable state
        // initialState.temp.logs.push(args)
    }
}
console.reportErrorsAsExceptions = false;

console.ina('EXTRA', Constants.expoConfig.extra)

initialState.server.url = Constants.expoConfig.extra?.url ? Constants.expoConfig.extra.url : initialState.server.url
initialState.server.api = Constants.expoConfig.extra?.api ? Constants.expoConfig.extra.api : initialState.server.api
initialState.settings.hideVersion = Constants.expoConfig.extra?.hideVersion != undefined ? Constants.expoConfig.extra.hideVersion == "true" : initialState.server.hideVersion
// initialState.commit = Constants.expoConfig.extra?.commit
initialState.commit = process.env.EXPO_PUBLIC_APP_COMMIT

console.log('EXPO_PUBLIC_APP_COMMIT', process.env.EXPO_PUBLIC_APP_COMMIT)

if (window.location) {
    const url = new URL(window.location)
    initialState.server.url = url.origin
    console.ina('ORIGIN', initialState.server.url)
}

export default initialState
